<!--
 * @Date: 2020-07
 * @LastEditTime: 2020-07-22 15:50
 * @Description: 工作组说明
--> 
<template>
 <div class="mainUser">
    <menberMenu :tit-names="titNames" :tit-urls="titUrls"></menberMenu>
    <div class="mainBox">
      <div class="listContent" style="padding:30px">
        <div class="bgBlueBox">
          <div class="Box_head">
            <i class="fa fa-q"></i> 
            <span class="title">Authority and purpose of the working team</span>
          </div>
          <div class="Box_content">
            <i class="fa fa-a"></i> 
            <div class="answer">
              <p>Administrator (Same permissions as me): it is convenient for other colleagues to handle my order.</p>
              <p>User (only can view his / her own order): Authorizes subordinate business, and can check the price and place an order by himself / herself.</p>
              <p>Work permissions: Freightshop establishes an account with the company as the unit. A company can only have one master account administrator" (first login to freightshop.com)</p>
              <p>Primary account permission: you can view the order data of yourself and all user accounts.</p>
              <p>User account permission: only your order data can be viewed. "</p>
            </div>
          </div>
        </div>
        <div class="bgBlueBox">
          <div class="Box_head">
            <i class="fa fa-q"></i> 
            <span class="title">I'm a leader. How can I make the lower level businesses use Freightshop. I can see the orders of all of them, which is convenient for management?</span>
          </div>
          <div class="Box_content">
            <i class="fa fa-a"></i>
            <div class="answer">
              <p>By adding the subordinate as "user" in the working group, the subordinate has its own Freightshop account, and he can only operate his own order. You can see all his orders.</p>
            </div>
          </div>
        </div>
        <div class="bgBlueBox">
          <div class="Box_head">
            <i class="fa fa-q"></i>
            <span class="title">How can I transfer my administrator status to superior leaders?</span>
          </div>
          <div class="Box_content">
            <i class="fa fa-a"></i>
            <div class="answer">
              <p>Give my account number to the superior, and ask the leader to replace his information with my information (email, name, phone, etc.). Then the leader added me as a user through the working group.</p>
            </div>
          </div>
        </div>
        <div style="text-align: center;margin-top:25px">
          <a href="/myInfo/basicInfo" class="blueBtnMin" >Back</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { post, fetch } from "@/ask/axios";
import menberMenu from '@/components/userCenter/public/menberPageMenu.vue';
export default {
  components: { menberMenu },
  data() {
    return {
      titNames: "Basic Info, My work team,Description",
      titUrls: "/myInfo/basicInfo,,",
    }
  }
}
</script>
<style scoped>
  @import "../../../assets/css/userCenterCss.css";
  .bgBlueBox{background-color: #F5F9FF;margin-bottom: 12px;padding: 20px;}
  .bgBlueBox .Box_head{line-height: 20px;font-size: 14px;margin-bottom: 16px;font-size: 0;}
  .bgBlueBox .Box_content{font-size: 0;}
  .bgBlueBox .Box_content p{line-height: 19px;font-size: 12px}
  .bgBlueBox  .fa-q{margin-right: 12px;font-size: 18px;color: #4A4A4A;}
  .bgBlueBox  .fa-a{margin-right: 12px;font-size: 18px;color: #EB9200;}
  .answer{display: inline-block;width: 95%;vertical-align: top;margin-top: -2px;}
  .bgBlueBox .Box_head .title{font-size: 14px;color: #000;font-weight: bold;vertical-align: bottom;}
  .blueBtnMin{padding:0px;width:100px;height:28px;display: inline-block;line-height: 28px;}
</style>


// WEBPACK FOOTER //
// src/components/userCenter/myInfo/workTeamDesc.vue